import { styled } from '@mui/material';
import { ActionButton } from 'src/components/ActionButton/ActionButton';

export const CustomActionButton = styled(ActionButton)(({ theme }) => ({
  '&.isFromNav': {
    width: '100%',
    height: theme.spacing(3),
    '& .MuiButton-root': {
      width: '100%',
      height: theme.spacing(4),
      minWidth: 'unset',
      '&:hover': {
        boxShadow: 'none',
      },
    },
  },
}));
